import React from 'react';
import '../../App.css';
import './Home.css';
import { makeStyles } from '@material-ui/core/styles';
import backgroundImage from '../../assets/images/homeBackground2.png';
import theme from '../../styles/theme.js';
import { Grid, Typography } from '@material-ui/core';
import NeritoLogoBig from '../../assets/images/logos/newNeritoLogoBig.svg';

import OurApp from '../../components/HomeComponents/OurApp';
import Business from '../../components/HomeComponents/Business';
import OurGroup from '../../components/HomeComponents/OurGroup';
import MoreBusiness from '../../components/HomeComponents/moreBusiness';
import MoreOurApp from '../../components/HomeComponents/moreOurApp';
import Carousel from '../../components/HomeComponents/Carousel';

const Home = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid container id="top">
        <Grid item xs={12}>
          <div className={classes.imageAndTextContainer}>
            <div className={classes.heroContent}>
              <img src={NeritoLogoBig} alt="Nerito" className={classes.neritoLogo} />

              <Typography className={classes.title}>
                Tu Dinero, Aquí y Allá, Siempre Contigo.
              </Typography>

              <Typography className={classes.subtitle}>
                Somos el puente entre tu esfuerzo y tu familia.
              </Typography>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} className={classes.secondSection}>
          <div className={classes.textContainer}>
            <Typography className={classes.greenTitle}>
              El Monedero Binacional
            </Typography>

            <Typography className={classes.thinTitle}>
              Es una plataforma digital que permite a
              <span className={classes.blackTitle}> mexicanos en U.S.A </span>
              abrir una cuenta con oferta de servicios financieros para mover tu dinero
              <span className={classes.blackTitle}> de USD a pesos mexicanos </span>
              de forma inmediata sin importar tu situación migratoria.
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Carousel />
        </Grid>
      </Grid>

      <Grid container id="OurApp">
        <Grid item xs={12}>
          <OurApp />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          <MoreOurApp />
        </Grid>
      </Grid>

      <Grid container id="OurGroup">
        <Grid item xs={12}>
          <OurGroup />
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;

const useStyles = makeStyles({
  container: {
    width: '100%',
    backgroundColor: theme.palette.white.main,
  },

  imageAndTextContainer: {
    position: 'relative',
    overflow: 'hidden',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: '100%',
    minHeight: '520px',
    padding: '150px 0',

    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: `
        linear-gradient(
          90deg,
          rgba(24,120,92,0.60) 0%,
          rgba(24,120,92,0.40) 55%,
          rgba(24,120,92,0.25) 100%
        )
      `,
      zIndex: 0,
    },

    [theme.breakpoints.down('md')]: {
      padding: '120px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '100px 16px',
    },
  },

  heroContent: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 900,
    padding: '0 24px',
    textAlign: 'center',
  },

  neritoLogo: {
    width: '40%',
    marginBottom: 24,
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
  },

  title: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 32,
    color: theme.palette.white.main,
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },

  subtitle: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.white.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },

  secondSection: {
    backgroundColor: theme.palette.greenBackground.main,
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 50,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: 30,
    },
  },

  greenTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 60,
    color: theme.palette.green.main,
    marginBottom: 20,
    [theme.breakpoints.down('md')]: {
      fontSize: 40,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
    },
  },

  thinTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 27,
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },

  blackTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    color: theme.palette.black.main,
  },
});
